import { createContext } from 'react';

import { EventType } from '../../types/module';

export interface BlogCardContextType {
  onCardClick?: (event: EventType) => void;
  hasSubtitleHover?: boolean;
  displaySubtitleOnSmallDevice?: boolean;
  hasTransparentBorders?: boolean;
  imgPosition?: 'top' | 'right' | 'bottom' | 'left' | 'none';
}

export const BlogCardContext = createContext<BlogCardContextType>({});
